// Collection page products grid script

// append product-slide children to the products grid
const productsGrid = document.querySelector("[data-products-grid]");
const loadMoreButton = document.querySelector("[data-load-more]");
let nextURL = productsGrid.dataset.nextUrl;
loadMoreButton.addEventListener("click", () => {
  fetch(nextURL).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    return response.text();
  }).then((html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    nextURL = doc.querySelector("[data-products-grid]").dataset.nextUrl;
    if (!nextURL) {
      loadMoreButton.remove();
    }
    const productSlides = doc.querySelectorAll("[data-slideshow-container]");
    productSlides.forEach((product) => {
      productsGrid.append(product);
    })
  }).catch((error) => {
    console.log(error);
  })
})
